import navBarSlice from './slices/navBarSlice';
import notificationSlice from './slices/notificationSlice';
import modalSlice from './slices/modalSlice';
import leaveSlice from './slices/leaveSlice';

const rootReducer = {
  navBar: navBarSlice,
  notifications: notificationSlice,
  modal  : modalSlice,
  leave: leaveSlice,
 
 
};

export default rootReducer;
